import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import PageSeo from '../components/Common/PageSeo';
import AppDevelopmentWeitereServices from '../components/AppDevelopment/AppDevelopmentWeitereServices';
import AppDevelopmentHeader from '../components/AppDevelopment/AppDevelopmentHeader';
import AppDevelopmentEigenschaften from '../components/AppDevelopment/AppDevelopmentEigenschaften';
import AppDevelopmentKundenprojekte from '../components/AppDevelopment/AppDevelopmentKundenprojekte';
import AppDevelopmentFAQ from '../components/AppDevelopment/AppDevelopmentFAQ';
import AppDevelopmentAppEntwicklungText from '../components/AppDevelopment/AppDevelopmentAppEntwicklungText';
import AppDevelopmentCTA from '../components/AppDevelopment/AppDevelopmentCTA';
import AppDevelopmentFlutterText from '../components/AppDevelopment/AppDevelopmentFlutterText';
import AppDevelopmentReactNativeText from '../components/AppDevelopment/AppDevelopmentReactNative';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const AppDevelopment = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('appDevelopment_page_title')}
                description={t('appDevelopment_page_description')}
                canonical={`${baseUrl}/app-development/`}
                openGraph={{
                    url: `${baseUrl}/app-development/`,
                    title: t('appDevelopment_page_ogTitle'),
                    description: t('appDevelopment_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('appDevelopment_page_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('appDevelopment_page_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('appDevelopment_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/app-development/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/app-development/'
                    }
                ]}
            />



            <Navbar />
            <AppDevelopmentHeader />
            <AppDevelopmentEigenschaften />
            <AppDevelopmentKundenprojekte />
            <AppDevelopmentAppEntwicklungText />
            <AppDevelopmentFlutterText />
            <AppDevelopmentReactNativeText />
            <AppDevelopmentCTA />
            <AppDevelopmentFAQ />
            <AppDevelopmentWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default AppDevelopment;